import React from 'react';
import './PlayToggle.css';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
}

/**
 * The prototype toggle (player Profile review, item 5): 44 by 26 track, 20px
 * white knob, branding gradient when on and #323232 when off. Play-local so
 * the shared ToggleSwitch keeps its own look elsewhere.
 */
export const PlayToggle: React.FC<Props> = ({ checked, onChange, disabled, ariaLabel }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    className={`play-toggle ${checked ? 'play-toggle--on' : ''}`}
    disabled={disabled}
    onClick={() => onChange(!checked)}
  >
    <span className="play-toggle__knob" aria-hidden="true" />
  </button>
);

export default PlayToggle;
